import React, { useState, useEffect, useCallback, forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/joy/Box';
import Table from '@mui/joy/Table';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import IconButton from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Tooltip from '@mui/joy/Tooltip';


///////////// Date Formate
import dateFormat, { masks } from "dateformat";



///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


///////////////////// Icons
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { visuallyHidden } from '@mui/utils';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReplyIcon from '@mui/icons-material/Reply';



////////////////// Form
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Textarea from '@mui/joy/Textarea';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

/////////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';


//////////////////// API
import { getAllComplians, updateComplians, deleteComplians } from '../../../Api/Complians';


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: 'اسم العميل',
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'البريد الالكتروني',
    },
    {
        id: 'createAt',
        numeric: true,
        disablePadding: false,
        label: 'تاريخ الشكوي',
    },
    {
        id: 'message',
        numeric: true,
        disablePadding: false,
        label: 'الشكوي',
    },
    {
        id: 'actions',
        numeric: true,
        disablePadding: false,
        label: 'الاجراءات',
    },
];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <thead>
            <tr style={
                { 'background': '#F3F3F3', 'color': '#7C7C7C', fontWeight: 'bold' }
            }>
                {/* <th>
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            slotProps={{
              input: {
                'aria-label': 'select all desserts',
              },
            }}
            sx={{ verticalAlign: 'sub' }}
          />
        </th> */}
                {headCells.map((headCell) => {
                    const active = orderBy === headCell.id;
                    return (
                        <th
                            key={headCell.id}
                            aria-sort={
                                active ? { asc: 'ascending', desc: 'descending' }[order] : undefined
                            }
                        >
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <Link
                                underline="none"
                                color="neutral"
                                textColor={active ? 'primary.plainColor' : undefined}
                                component="button"
                                onClick={createSortHandler(headCell.id)}
                                fontWeight="lg"
                                startDecorator={
                                    headCell.numeric ? (
                                        <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                                    ) : null
                                }
                                endDecorator={
                                    !headCell.numeric ? (
                                        <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                                    ) : null
                                }
                                sx={{
                                    '& svg': {
                                        transition: '0.2s',
                                        transform:
                                            active && order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                                    },
                                    '&:hover': { '& svg': { opacity: 1 } },
                                }}
                            >
                                {headCell.label}
                                {active ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </Link>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                py: 1,
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: 'background.level1',
                }),
                borderTopLeftRadius: 'var(--unstable_actionRadius)',
                borderTopRightRadius: 'var(--unstable_actionRadius)',
            }}
        >
            {numSelected > 0 ? (
                <Typography sx={{ flex: '1 1 100%' }} component="div">
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography
                    level="body-lg"
                    sx={{ flex: '1 1 100%' }}
                    id="tableTitle"
                    component="div"
                >
                    Nutrition
                </Typography>
            )}

            {numSelected > 0 ? (
                <Tooltip title="Delete">
                    <IconButton size="sm" color="danger" variant="solid">
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ) : false}
        </Box>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


const schema = yup.object({
    reply: yup.string().required("هذا الحقل مطلوب")
})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function TableComplaints() {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('calories');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(0);
    const [rows, setRows] = useState([]);

    
    const [loadingDelete, setLoadingDelete] = useState(null);
    const [loading, setLoading] = useState(null);
    const [actionType, setActionType] = useState(null);
    const [statusType, setStatusType] = useState(null);
    const [statusContentAlert, setStatusContentAlert] = useState(null);
    const [contentReplyMessage, setContentReplyMessage] = useState(null);
    
    
    const [messageId, setMessageId] = useState(null);
    const [messageIdDelete, setMessageIdDelete] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');


    //////////////////// Use Form
    const form = useForm({
        defaultValues: {
            reply: null
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    //   const handleClick = (event, name) => {
    //     const selectedIndex = selected.indexOf(name);
    //     let newSelected = [];

    //     if (selectedIndex === -1) {
    //       newSelected = newSelected.concat(selected, name);
    //     } else if (selectedIndex === 0) {
    //       newSelected = newSelected.concat(selected.slice(1));
    //     } else if (selectedIndex === selected.length - 1) {
    //       newSelected = newSelected.concat(selected.slice(0, -1));
    //     } else if (selectedIndex > 0) {
    //       newSelected = newSelected.concat(
    //         selected.slice(0, selectedIndex),
    //         selected.slice(selectedIndex + 1),
    //       );
    //     }

    //     setSelected(newSelected);
    //   };

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };


    const isSelected = (name) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;


    ////////////////// Replay Message
    const replayMessage = (e, id) => {
        e.preventDefault()
        setActionType('replay')
        setStatusType('الرد على الشكوي')
        setStatusContentAlert('')
        setMessageId(id)
        setOpenModal(true)
    }


    /////////////////// Show Complaints Details
    const showDetailsMessage = (e, row) => {
        e.preventDefault()
        setActionType('show')
        setStatusType(' تفاصيل الشكوي')
        setStatusContentAlert(row.message)
        setContentReplyMessage(row.reply)
        setOpenModal(true)
    }

    const deleteMessage = (e, id) => {
        setMessageIdDelete(id)
        setOpenModalConfirmDelete(true)
    }

    const removeMessage = async () => {
        setLoadingDelete(true)
        const res = await deleteComplians(messageIdDelete)
        if(res) {
            setLoadingDelete(false)
            setMessageAlert('تم حذف الشكوي بنجاح')
            setOpenAlert(true)
            setOpenModalConfirmDelete(false)
            getListComplians()
        }
    }



    ////////////////// Action send Relay Message
    const sendReplay = async (data) => {
        setLoading(true)
        const res = await updateComplians(messageId, data)
        if (!res) {
            setMessageAlert('هناك خطأ اعد المحاولة مره اخرى')
            setOpenAlert(true)
        }
        setValue('reply', null)
        setLoading(false)
        getListComplians()
        setMessageAlert('تم ارسال الرد على الشكوي')
        setOpenAlert(true)
        setOpenModal(false)
        setMessageId(null)
        setStatusType(null)
        setStatusContentAlert(null)
        setActionType(null)
    }

    ////////////////// Get all Rate
    const getListComplians = useCallback(async () => {
        const res = await getAllComplians()
        if (!res) {
            return
        }
        setRows(res)
    }, [])

    useEffect(() => {
        getListComplians();
    }, [getListComplians])


    return (
        <>

            {/* Alert Meesage */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>


            {/* Modal PopUp Reply And Show details */}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        {statusType}
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        {statusContentAlert}
                    </Typography>

                    {actionType == 'show' && contentReplyMessage &&(
                        <>
                            <Typography id="nested-modal-title" level="h2">
                                تفاصيل الرد على الشكوى
                            </Typography>
                            <Typography id="nested-modal-description" textColor="text.tertiary">
                                {contentReplyMessage}
                            </Typography>
                        </>
                    )}


                    {actionType != 'show' && (
                        <form onSubmit={handleSubmit(sendReplay)}>
                            <FormControl>
                                <FormLabel>الاجابة على الشكوي</FormLabel>
                                <Textarea
                                    placeholder="اكتب هنا ..."
                                    minRows={4}
                                    sx={{
                                        width: '500px',
                                        '--Textarea-focusedInset': 'var(--any, )',
                                        '--Textarea-focusedThickness': '0.25rem',
                                        '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                        '&::before': {
                                            transition: 'box-shadow .15s ease-in-out',
                                        },
                                        '&:focus-within': {
                                            borderColor: '#86b7fe',
                                        },
                                    }}
                                    {...register('reply')}
                                />
                                {errors.reply &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.reply?.message}</Typography>
                                }
                            </FormControl>

                            <Box
                                sx={{
                                    mt: 1,
                                    display: 'flex',
                                    gap: 1,
                                    flexDirection: { xs: 'column', sm: 'row-reverse' },
                                }}
                            >
                                {actionType != 'show' && (
                                    <Button type='submit' variant="solid" loading={loading} color="primary">
                                        ارسال
                                    </Button>
                                )}
                                <Button
                                    variant="outlined"
                                    color="neutral"
                                    onClick={() => setOpenModal(false)}
                                >
                                    الغاء
                                </Button>
                            </Box>
                        </form>
                    )}

                    {actionType == 'show' && (
                        <Box
                            sx={{
                                mt: 1,
                                display: 'flex',
                                gap: 1,
                                flexDirection: { xs: 'column', sm: 'row-reverse' },
                            }}
                        >
                            <Button
                                variant="outlined"
                                color="neutral"
                                onClick={() => setOpenModal(false)}
                            >
                                الغاء
                            </Button>
                        </Box>
                    )}
                </ModalDialog>
            </Modal>

            {/* Modal PopUp Confirm Delete Message */}
            <Modal open={openModalConfirmDelete} onClose={() => setOpenModalConfirmDelete(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف الشكوي ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف الشكوي بشكل دائم وإزالة بياناته من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" loading={loadingDelete} color="primary" onClick={() => removeMessage()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModalConfirmDelete(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>



            <Sheet
                variant="outlined"
                sx={{ width: '100%', boxShadow: 'sm', borderRadius: 'sm' }}
            >
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <Table
                    aria-labelledby="tableTitle"
                    hoverRow
                    sx={{
                        '--TableCell-headBackground': 'transparent',
                        '--TableCell-selectedBackground': (theme) =>
                            theme.vars.palette.success.softBg,
                        // '& thead th:nth-child(1)': {
                        //   width: '40px',
                        // },
                        '& thead th:nth-child(1)': {
                            // width: '40px',
                            textAlign: 'center'
                        },
                        '& tr > *:nth-child(n+3)': { textAlign: 'center' },

                        '& tr > *:nth-child(1)': { textAlign: 'center' },
                        '& tr > *:nth-child(2)': { textAlign: 'center' },
                    }}
                >
                    <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                    />

                    <tbody>
                        {stableSort(rows, getComparator(order, orderBy))
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                const isItemSelected = isSelected(row.name);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <tr
                                        // onClick={(event) => handleClick(event, row.name)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        // selected={isItemSelected}
                                        style={
                                            isItemSelected
                                                ? {
                                                    '--TableCell-dataBackground':
                                                        'var(--TableCell-selectedBackground)',
                                                    '--TableCell-headBackground':
                                                        'var(--TableCell-selectedBackground)',
                                                }
                                                : {}
                                        }
                                    >
                                        <th id={labelId} scope="row">
                                            {row.name}
                                        </th>
                                        <td>{row.email}</td>
                                        {/* <td>{row.user.subscribe}</td> */}
                                        <td>{dateFormat(row.created_at, "yyyy-mm-dd")}</td>
                                        <td>{row.message}</td>
                                        <td>
                                            <VisibilityIcon sx={{ cursor: 'pointer' }} color='primary' onClick={(e) => showDetailsMessage(e, row)} />
                                            <ReplyIcon sx={{ cursor: 'pointer', margin: '0 10px' }} color='primary' onClick={(e) => replayMessage(e, row.id)} />
                                            <DeleteIcon sx={{ cursor: 'pointer', margin: '0 10px' }} color='error' onClick={(e) => deleteMessage(e, row.id)} />
                                        </td>
                                    </tr>
                                );
                            })}
                        {emptyRows > 0 && (
                            <tr
                                style={{
                                    height: `calc(${emptyRows} * 40px)`,
                                    '--TableRow-hoverBackground': 'transparent',
                                }}
                            >
                                <td colSpan={6} aria-hidden />
                            </tr>
                        )}
                    </tbody>

                </Table>
            </Sheet>
        </>
    );
}